exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-uploads-transition .card[data-v-20b6e0dd]{transition:transform .15s}.file-limit-reached[data-v-20b6e0dd]{padding:0 5px;color:#ccc}.caption-uploader[data-v-20b6e0dd]{padding:10px 10px 15px}", ""]);

// exports
